import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

export interface MarketplaceDistribution {
  name: string;
  value: number;
  color: string;
  total_tasks: number;
  success_rate: number;
}

export const useMarketplaceDistribution = () => {
  return useQuery<MarketplaceDistribution[]>(
    'marketplaceDistribution',
    async () => {
      const response = await apiClient.get('/api/v1/scraper/statistics/marketplace-distribution');
      return response.data;
    },
    {
      refetchInterval: 600000,
      staleTime: 120000,
      cacheTime: 600000,
    }
  );
};
